import styled from "styled-components";

export const BaseStationChartStyle=styled.div`

    .chartheading{
        display: flex;
        justify-content: center;
        font-family:  "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica, "Arial Narrow", sans-serif;
        font-weight:700;
        font-size:20px;
    }
    .chartdiv{

        width: 300px; /* Set the desired width */
        height: 300px; /* Set the desired height */
        margin: 20px auto;
        display: flex;
        justify-content: center;
    }

`